<template>
  <div class="total-payment">
    <div class="total-payment-detail">
      <div class="total-payment-title">Pagar el total de mi compra ahora</div>
      <span
        >La opción de siempre para hacer tus comprar en Joinnus puedes seguir realizando de esta
        forma.</span
      >
      <div class="total-payment-total">{{meta.currency}} {{meta.total}}</div>
      <div class="total-payment-buttons">
        <button type="button" class="btn btn btn-primary btn-round" @click="goStep()">Ir a pagar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTotalPayment',
   props:{
    meta:{
      type: Object,
      requerid: true,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    }
  },
  data() {
    return {};
  },
  methods:{
    goStep(){
      this.$store.dispatch('changeStep',5);
      this.$store.dispatch('updateFeePayments', []);
    }
  }
};
</script>
<style lang="scss" scoped>
.total-payment {
  &-title {
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 15px;
  }
  &-detail {
    border-radius: 8px;
    border: 1px solid #bcc8d9;
    padding: 15px 20px;
    margin-bottom: 30px;
  }
  &-total {
    text-align: center;
    font-weight: bold;
    font-size: 1.5rem;
    margin: 1rem;
  }
  &-buttons {
    text-align: center;
  }
}
</style>
